<template>
  <div>
    <CCTVMenuTop />
    <CCTVMap />
    <br>
    <CCTVStatistics />
    <br>
    <CCTVChart />
    <CCTVRTSP />
    <br>
    <CCTVTable />
  </div>
</template>

<script>
import CCTVMap from '@/views/cctv/total/CCTVMap.vue'
import CCTVStatistics from '@/views/cctv/total/CCTVStatistics.vue'
import CCTVRTSP from '@/views/cctv/total/CCTVRTSP.vue'
import CCTVTable from '@/views/cctv/total/CCTVTable.vue'
import CCTVMenuTop from '@/views/cctv/total/CCTVMenuTop.vue'
import CCTVChart from '@/views/cctv/total/CCTVChart.vue'
// import axios from '@axios'
export default {
  components: {
    CCTVMap,
    CCTVStatistics,
    CCTVRTSP,
    CCTVTable,
    CCTVMenuTop,
    CCTVChart,
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  },
}
</script>

  <style>
  </style>
